import { ColumnDefinition } from 'src/types/tableDataSet'

export const getExcelColumnLabel = (index: number): string => {
  let label = ''
  let i = index
  while (i >= 0) {
    label = String.fromCharCode((i % 26) + 65) + label
    i = Math.floor(i / 26) - 1
  }
  return label
}

const renderNumber = (val: number, unit?: string) => (
  <span className="cell-number">
    {val.toLocaleString('es-ES')}
    {unit && <span className="cell-unit">{unit}</span>}
  </span>
)
const renderPoint = (val: string) => (
  <code className="cell-point" title="Lat, Long">
    {val}
  </code>
)
const renderDate = (val: string, type: 'date' | 'time' | 'datetime') => {
  return <span className={`cell-date type-${type}`}>{val}</span>
}
const renderBoolean = (val: boolean) => (
  <span className={`cell-bool ${val ? 'true' : 'false'}`}>
    {val ? 'Yes' : 'No'}
  </span>
)
const renderDefault = (val: string | number) => (
  <span className="cell-default">{val}</span>
)
const renderEmpty = () => <span className="cell-empty">-</span>

export const getCellContent = (
  val: string | number | boolean | null,
  colDef: ColumnDefinition
) => {
  if (val === null || val === undefined) return renderEmpty()

  switch (colDef.type) {
    case 'number':
    case 'currency':
    case 'percentage':
      return renderNumber(val as number, colDef.unit)
    case 'point':
      return renderPoint(val as string)
    case 'date':
    case 'time':
    case 'datetime':
      return renderDate(val as string, colDef.type)
    case 'boolean':
      return renderBoolean(val as boolean)
    case 'string':
    default:
      return renderDefault(val as string | number)
  }
}
